import download from 'downloadjs'
import * as formats from '../constants/formats'
import { fetchBlobWithErrorHandling } from '../utils/fetch'

export default async function({ format, ...options }) {
	switch (format) {
		case formats.PDF:
			await exportFile("pdf", "pdf", "application/pdf", options)
			break
		case formats.GEOJSON:
			await exportFile("json", "json", "application/vnd.geo+json", options)
			break
		case formats.CSV:
			await exportFile("csv", "csv", "text/csv", options)
			break
		case formats.K_FIL:
			await exportFile("kfil", "k", "text/plain", options)
			break
		default:
			throw new Error("Unsupported export format.")
	}
}

async function exportFile(path, fileEnding, mime, { ids, srid, fields }) {
	const data = await fetchBlobWithErrorHandling({
		path: `/export/${path}`,
		query: {
			srid,
			columns: fields
		},
    	method: "POST",
        headers: {
            "Content-Type": "application/json",
            "Accept": `${mime}, application/json; q=0.9`
        },
        body: JSON.stringify(ids),
	})
	download(data, `stompunkter.${fileEnding}`, mime)
}

export const formatHasColumns = (format) => format === formats.CSV || format === formats.K_FIL



// WEBPACK FOOTER //
// ./src/export/exportStompunkter.js